var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-info"},[_c('div',{staticClass:"website-info-content"},[_c('div',{staticClass:"website-info-text-2"},[_c('p',[_vm._v("版权所有："+_vm._s(_vm.companyName)+"       Copyright ©2024. All Rights Reserved "+_vm._s(_vm.reserved)+"       法律声明 | 所有内容未经授权,不得转载或做其他使用,违者必究")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }